(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('FeedbackALController', FeedbackALController);

    FeedbackALController.$inject = ['Principal','OTPService','$state'];

    function FeedbackALController (Principal,OTPService,$state) {
        var vm = this;
        var isAuthenticated=Principal.isAuthenticated();
        vm.cancel=cancel;
        vm.feedbacksubmit=feedbacksub;
        vm.feedback={};
        vm.success=false;
        function cancel(){
        if(isAuthenticated){
        $state.go('home');	
        }else{
        	$state.go('login');
        }
        }
        
        function feedbacksub(){
        	OTPService.sendfeedback(vm.feedback).then(function(response)
        			{
        		vm.oopsmes=false;
        		vm.success=true;
        			})["catch"](function(response){
        				vm.success=false;
        				vm.oopsmes=true;
        			})
        }
    }
})();
